export const StepsConstants = {
  totalPercent: 100,
};
